/* Dawn's page-load summary setup is not rerun for newly inserted editor sections. */
if (!customElements.get('hence-header-controls')) {
  customElements.define('hence-header-controls', class extends HTMLElement {
    connectedCallback() {
      this.onToggle = (event) => {
        if (event.target.matches('.header__inline-menu details')) this.sync(event.target);
      };
      this.onEscape = (event) => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('.header__inline-menu details[open]');
        if (!details || !this.contains(details)) return;
        details.open = false;
        this.sync(details);
        details.querySelector(':scope > summary').focus();
        event.stopPropagation();
      };
      this.onAnchor = (event) => {
        const link = event.target.closest('header-drawer a[data-quiet-anchor]');
        if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const drawer = link.closest('header-drawer');
        const summary = drawer.querySelector(':scope > details > summary');
        if (typeof drawer.closeMenuDrawer === 'function') {
          drawer.closeMenuDrawer(event, summary);
          summary.setAttribute('aria-expanded', 'false');
        }
      };
      this.headerSection = this.closest('.section-header');
      this.syncHeroNavigation = () => {
        const hero = document.querySelector('.hence-native-hero #preparation');
        const stage = hero?.querySelector('.hero-study-stage');
        const header = this.querySelector('.header');
        const boundary = hero?.classList.contains('mix-scroll')
          ? stage.offsetHeight + parseFloat(getComputedStyle(stage).top)
          : header.offsetHeight + 24;
        this.headerSection.classList.toggle('hero-nav-active', Boolean(hero && hero.getBoundingClientRect().bottom > boundary));
      };
      window.addEventListener('scroll', this.syncHeroNavigation, { passive: true });
      window.addEventListener('resize', this.syncHeroNavigation);
      document.addEventListener('shopify:section:load', this.syncHeroNavigation);
      document.addEventListener('shopify:section:unload', this.syncHeroNavigation);
      this.heroResize = new ResizeObserver(this.syncHeroNavigation);
      this.heroResize.observe(this.querySelector('.header'));
      this.syncHeroNavigation();
      this.addEventListener('click', this.onAnchor);
      this.querySelectorAll('.header__inline-menu details').forEach((details) => this.sync(details));
      this.addEventListener('toggle', this.onToggle, true);
      this.addEventListener('keyup', this.onEscape, true);
    }

    sync(details) {
      const summary = details.querySelector(':scope > summary');
      summary.setAttribute('aria-expanded', String(details.open));
      if (summary.nextElementSibling?.id) summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.syncHeroNavigation);
      window.removeEventListener('resize', this.syncHeroNavigation);
      document.removeEventListener('shopify:section:load', this.syncHeroNavigation);
      document.removeEventListener('shopify:section:unload', this.syncHeroNavigation);
      this.heroResize.disconnect();
      this.headerSection.classList.remove('hero-nav-active');
      this.removeEventListener('click', this.onAnchor);
      this.removeEventListener('toggle', this.onToggle, true);
      this.removeEventListener('keyup', this.onEscape, true);
      const drawer = this.querySelector('header-drawer');
      const details = drawer?.querySelector('details[open]');
      if (details) drawer.closeMenuDrawer(new Event('section-unload'), details.querySelector('summary'));
    }
  });
}
